import { isDesktop } from 'NewAngular/utils/media';
export default class ChartImageHelper {
    constructor(imageUrl) {
        this.imageUrl = imageUrl;
    }
    download() {
        // Some iPads have desktop-like dimensions when used in landscape orientation,
        // so we also need to check the user agent. The image must be opened in a separate tab
        // for the image download to work on tablets.
        const isIpad = /ipad|macintosh/.test(window.navigator.userAgent.toLowerCase()) && 'ontouchend' in document;
        if (!isDesktop() || isIpad) {
            window.open(this.imageUrl, '_blank');
        }
        else {
            const link = document.createElement('a');
            link.href = this.imageUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    print(disclosure, AIEventsHTML = null) {
        const printFrame = document.createElement('iframe');
        printFrame.setAttribute('style', 'position: absolute; top: -1000px;');
        printFrame.setAttribute('src', 'about:blank');
        printFrame.onload = () => {
            if (!printFrame?.contentWindow)
                return;
            const doc = printFrame.contentDocument || printFrame.contentWindow?.document;
            doc.body.setAttribute('style', 'height:100%; width:100%; margin:0; padding:0;');
            const img = doc.createElement('img');
            img.setAttribute('src', this.imageUrl);
            img.setAttribute('style', 'display:block; width:100%; max-height:100%; page-break-after: always;');
            // Set an event listener to print the iframe once the image has loaded.
            img.onload = () => {
                if (!printFrame?.contentWindow)
                    return;
                printFrame.contentWindow.print();
            };
            // Append img to iframe body.
            doc.body.appendChild(img);
            if (AIEventsHTML) {
                const AIEvents = doc.createElement('div');
                AIEvents.innerHTML = AIEventsHTML;
                AIEvents.setAttribute('style', 'font-family: Roboto Condensed, sans-serif;');
                doc.body.appendChild(AIEvents);
            }
            // If we have a disclosure then append it as a second page.
            if (disclosure) {
                const disclosureElement = doc.createElement('div');
                // disclosure contains HTML markup and thus we need to set `innerHTML`.
                disclosureElement.innerHTML = disclosure;
                disclosureElement.setAttribute('style', 'font-family: Roboto Condensed, sans-serif;');
                doc.body.appendChild(disclosureElement);
            }
        };
        document.body.appendChild(printFrame);
    }
}
